import { Field } from 'react-final-form'
import { lighten, useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

type FormErrorProps = {
  name: string
}

type ErrorProps = {
  error: any
}

export const Error = ({ error }: ErrorProps) => {
  const theme = useTheme()

  return (
    <Typography
      variant="body2"
      sx={{
        mt: 5,
        mb: 5,
        padding: '16px 24px',
        background: lighten(theme.palette.primary.main, 0.8),
        borderLeft: `5px solid`,
        borderLeftColor: 'primary.main',
      }}
    >
      {error}
    </Typography>
  )
}

const FormError = ({ name }: FormErrorProps) => {
  const theme = useTheme()

  return (
    <Field
      name={name}
      subscription={{ touched: true, error: true }}
      render={({ meta: { touched, error } }) =>
        touched && error ? (
          <Typography
            variant="body2"
            sx={{
              mt: 5,
              mb: 5,
              padding: '16px 24px',
              background: lighten(theme.palette.primary.main, 0.8),
              borderLeft: `5px solid`,
              borderLeftColor: 'primary.main',
            }}
          >
            {error}
          </Typography>
        ) : null
      }
    />
  )
}

export default FormError
